import React, { useEffect, useState } from "react";
import {
  PageHeader,
  Row,
  Col,
  Breadcrumb,
  Spin,
  Form,
  Input,
  Button,
  Popconfirm,
  InputNumber,
  message,
  DatePicker,
} from "antd";
import Page from "_components/Page";
import { Link } from "react-router-dom";

import { taxTypeService } from "_services";
import moment from "moment";

function Summary({ match, history }) {
  const { id } = match.params;
  const { path } = match;
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getTaxTypeById(id);
  }, [id]);

  const handleOnFormSubmit = () => {
    setLoading(true);
    form
      .validateFields()
      .then((values) => {
        const payload = {
          ...values,
          validFrom: moment(values?.validFrom).format("YYYY-MM-DD"),
          validTo: moment(values?.validTo).format("YYYY-MM-DD"),
        };
        console.log(payload);

        taxTypeService
          .update(id, payload)
          .then(() => {
            message.success("Successfully Updated!", 3);
            history.push("../");
            setLoading(false);
          })
          .catch((error) => {
            setLoading(false);
            message.error(error);
          });
      })
      .catch((error) => {
        message.error(error);
        setLoading(false);
      });
  };

  const getTaxTypeById = (id) => {
    if (id == null || id == undefined) return;

    setLoading(true);
    taxTypeService
      .getById(id)
      .then((data) => {
        onFill(data.content);
        setLoading(false);
      })
      .catch((error) => {
        message.error(error);
        setLoading(false);
      });
  };
  const onCancel = () => {
    history.push(".");
  };

  const onFill = (data) => {
    form.setFieldsValue({
      ...data,
      validFrom: moment(data.validFrom).isValid()
        ? moment(data.validFrom)
        : moment(),
      validTo: moment(data.validTo).isValid() ? moment(data.validTo) : moment(),
    });
  };
  const getActionButtons = () => {
    let buttons = [];
    buttons.push(<Button onClick={onCancel}>Cancel</Button>);
    buttons.push(
      <Popconfirm
        title={`Are you sure to Update it?`}
        onConfirm={handleOnFormSubmit}
        placement="left"
        key="updateButtonKey"
      >
        <Button
          key="btn-update"
          type="primary"
          htmlType="button"
          loading={loading}
        >
          Update
        </Button>
      </Popconfirm>
    );

    return buttons;
  };
  return (
    <PageHeader
      title={
        <Breadcrumb>
          <Breadcrumb.Item>
            <Link to="/dashboard">Dashbaord</Link>
          </Breadcrumb.Item>

          <Breadcrumb.Item>
            <Link to="/tax-types">Tax Type</Link>
          </Breadcrumb.Item>

          <Breadcrumb.Item>
            <Link to={`${path}`.replace(":id", id)}>Summary</Link>
          </Breadcrumb.Item>
        </Breadcrumb>
      }
      extra={getActionButtons()}
    >
      <Spin spinning={loading}>
        <Page inner>
          <Form name="form-edit" form={form} layout="vertical">
            <Row gutter={24}>
              <Col span={6}>
                <Form.Item label="Code" name={["code"]}>
                  <Input disabled />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item label="Name" name={["name"]}>
                  <Input />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item label="Description" name={["description"]}>
                  <Input />
                </Form.Item>
              </Col>

              <Col span={6}>
                <Form.Item label="Rate" name={["rate"]}>
                  <InputNumber className="fullWidth" />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={24}>
              <Col span={6}>
                <Form.Item label="Valid From" name={["validFrom"]}>
                  <DatePicker className="fullWidth" />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item label="Valid To" name={["validTo"]}>
                  <DatePicker className="fullWidth" />
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Page>
      </Spin>
    </PageHeader>
  );
}

export default Summary;
